// ============================================
// CONFIGURATION API — PEFEP Site
// ============================================

export const API_URL =
  process.env.REACT_APP_API_URL || 'https://pefep.site';
